export default __webpack_public_path__ + "static/media/MicroBit.f5e1b663.webp";